<template>
  <ContentBanner
    :variant="bannerConfig.variant"
    :icon="bannerConfig.icon"
    :title="bannerConfig.title"
    primary-label="Send Reminder"
  >
    <p class="text-body-3 text-textLight mb-0">
      This employee has had an acknowledgement pending for <strong>{{ daysPending }}</strong> days.
      <a
        href="https://help.datapeople.io/article/342-acknowledgements-slas"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary text-decoration-none cursor-pointer"
        @click.stop
      >Read more here.</a>
    </p>
    <template #actions>
      <HideRbac :permissions="['sendJobProfileAcknowledgementReminders']">
        <DpplTooltip
          v-if="!canSendReminder"
          tooltip-placement="bottom"
        >
          <template #activator="{ onMouseenter, onMouseleave }">
            <span
              class="banner-action-disabled-wrapper"
              @mouseenter="onMouseenter"
              @mouseleave="onMouseleave"
            >
              <v-btn
                color="brandPrimary"
                variant="flat"
                size="small"
                disabled
              >
                Send Reminder
              </v-btn>
            </span>
          </template>
          <template #tooltip-content>
            <p class="text-body-2 text-textDark">
              {{ sendReminderDisabledTooltip }}
            </p>
          </template>
        </DpplTooltip>
        <v-btn
          v-else
          color="brandPrimary"
          variant="flat"
          size="small"
          @click="handleSendReminder"
        >
          Send Reminder
        </v-btn>
      </HideRbac>
      <HideRbac :permissions="['cancelEmployeeJobProfileAcknowledgements']">
        <v-btn
          variant="outlined"
          size="small"
          color="error"
          class="content-banner-secondary-btn content-banner-secondary-btn-error"
          @click="handleCancel"
        >
          Cancel
        </v-btn>
      </HideRbac>
    </template>
  </ContentBanner>
</template>

<script setup>
import ContentBanner from '@/components/library/ContentBanner.vue';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import HideRbac from '@/components/rbac/HideRbac.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG } from '@/helpers/acknowledgementAlerts';

const bannerConfig = ACKNOWLEDGEMENT_PREVIEW_BANNER_CONFIG.pending_acknowledgement;

defineProps({
  daysPending: { type: Number, default: 0 },
  canSendReminder: { type: Boolean, default: true },
  sendReminderDisabledTooltip: { type: String, default: '' },
});

const emit = defineEmits(['send-reminder', 'cancel']);

const handleSendReminder = () => {
  useTracking().ackLibClickedRemind({ location: 'In Sidebar Alert window' });

  emit('send-reminder');
};

const handleCancel = () => {
  useTracking().ackLibClickedCancel({ location: 'In Alert window' });

  emit('cancel');
};
</script>

<style scoped lang="less">
.banner-action-disabled-wrapper {
  display: inline-block;
}
</style>
